import React, { useMemo } from "react"
import classNames from "classnames"
import { toNumber } from "lodash-es"

import styles from "./index.module.less"

interface IProps {
    value?: string
    className?: string
    style?: React.CSSProperties
}

const Percent: React.FC<IProps> = (props) => {
    const { value = "0.00", className, style } = props

    const { integer, decimal } = useMemo(() => {
        let val = value

        const number = toNumber(val) || 0
        if (number <= 0) {
            val = "0.00"
        } else if (number >= 100) {
            val = "100.00"
        }

        const values = val.split(".")
        return {
            integer: values[0],
            decimal: values[1],
        }
    }, [value])

    return (
        <div className={classNames(styles.percent, className)} style={style}>
            <span className={styles.integer}>{integer}</span>
            <span>.</span>
            <span>{decimal}</span>
            <span>%</span>
        </div>
    )
}

export default Percent
